import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-access-denied',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslatePipe],
  template: `
    <div class="min-h-[50vh] flex flex-col items-center justify-center p-6 text-center space-y-4">
      <h1 class="text-2xl font-bold text-gray-900 dark:text-gray-100">
        {{ 'ACCESS_DENIED.TITLE' | translate }}
      </h1>
      <p class="text-gray-600 dark:text-gray-400 max-w-md">
        {{ 'ACCESS_DENIED.DESC' | translate }}
      </p>
      <a
        routerLink="/app/settings"
        class="inline-flex items-center justify-center rounded-md bg-gray-900 text-white px-4 py-2 text-sm font-medium hover:bg-gray-800"
      >
        {{ 'ACCESS_DENIED.BACK' | translate }}
      </a>
    </div>
  `,
})
export class AccessDeniedComponent {}
